// extracted by mini-css-extract-plugin
export default {"inputAutocomplete":"InputAddressAutocomplete_inputAutocomplete__F2QKr","error":"InputAddressAutocomplete_error__ntrJw"};